<!-- eslint-disable -->
<template lang="pug">
    .opponent(v-if="opponent")
        .opponent__loader(v-if="status === 'invitation_sent'")
            img(src="../../../assets/images/battles/loader.png")
        .opponent__title(v-if="status !== 'invitation_declined'") {{ title }}
        .opponent__avatar
            img(:src="opponent.avatar")
        .opponent__full-name {{ opponent.fullName + " (" + opponent.city + ") " }}
        .opponent__play-text(v-if="status !== 'invitation_sent'") {{ text }}
        button.button.opponent__button(:class=`{
                'opponent__button_blue': status === 'invitation_accepted' || status === 'invitation_declined',
                'opponent__button_orange': status === 'invitation_sent',
            }`, @click="buttonAction")
            | {{ buttonText }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';

    import {
        INVITATION_ACCEPTED_STATUS,
        INVITATION_DECLINED_STATUS,
        INVITATION_SENT_STATUS,
        DECLINE_INVITATION,
        IGNORE_INVITATION
    } from "../../../config/battle";

    export default {
        props: {
            opponent: {
                type: Object,
                default: null,
            },
            status: {
                type: String,
                default: INVITATION_SENT_STATUS
            },
            declineType: {
                type: String,
                default: ''
            },
            isTraining: {
                type: Boolean,
                default: false,
            }
        },
        methods: {
            buttonAction () {
                switch (this.status) {
                    case INVITATION_SENT_STATUS: {
                        this.$emit('cancelInvite', false);
                        break;
                    }
                    case INVITATION_DECLINED_STATUS: {
                        this.$store.dispatch('setBattleDeclined', false);
                        this.$router.push({name: this.prevRoute.name, params: this.prevRoute.params});
                        break;
                    }
                    case INVITATION_ACCEPTED_STATUS: {
                        this.$emit('startBattle');
                        break;
                    }
                }
            },
        },
        computed: {
            ...mapState({
                prevRoute: state => state.router.previousRoute,
            }),
            title () {
                switch (this.status) {
                    case INVITATION_SENT_STATUS: {
                        return this.$i18n.t('battle.battle_invitation_sent');
                    }
                    case INVITATION_ACCEPTED_STATUS: {
                        return this.$i18n.t('battle.battle_invitation_accepted')
                            + " " + this.$i18n.t('battle.battle_your_opponent');
                    }
                    default: {
                        return this.$i18n.t('battle.battle_your_opponent');
                    }
                }
            },
            text () {
                if (this.declineType === IGNORE_INVITATION) {
                    return this.$i18n.t('battle.battle_invitation_ignored');
                } else if (this.status === INVITATION_DECLINED_STATUS && this.declineType === DECLINE_INVITATION) {
                    return this.$i18n.t('battle.battle_invitation_declined')[this.opponent.sex];
                } else {
                    return this.$i18n.t('battle.battle_are_you_ready_to_start');
                }
            },
            buttonText () {
                switch (this.status) {
                    case INVITATION_SENT_STATUS: {
                        return this.$i18n.t('trainer.trainer_generator_cancel');
                    }
                    case INVITATION_DECLINED_STATUS: {
                        return this.$i18n.t('battle.battle_back_to_opponents_list');
                    }
                    case INVITATION_ACCEPTED_STATUS: {
                        return this.$i18n.t('battle.battle_yes') + "!";
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .opponent {
        max-height: 300px;
        max-width: 600px;
        margin: 0 auto;
        padding: 20px;
        background: #F7F7FF;
        border-radius: 20px;

        font-family: Rubik;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 28px;
        text-align: center;
    }
    .opponent__loader {
        width: 60px;
        height: 60px;
        margin: 0 auto;
        animation: spin 2s linear infinite;
    }
    @keyframes spin {
        100% {
            transform: rotate(360deg);
        }
    }
    .opponent__avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin: 0 auto 15px;
        img {
            height: 100%;
        }
    }
    .opponent__title, .opponent__play-text {
        font-size: 22px;
        line-height: 26px;
        color: #333333;
        margin-bottom: 15px;
    }
    .opponent__full-name {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        color: #333333;
        margin-bottom: 15px;
    }
    .button {
        height: auto;
        border-radius: 40px;
        padding: 15px 30px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        border: 0;
    }
    .opponent__button {
        margin-bottom: 30px;
        color: #FFFFFF;
    }
    .opponent__button_blue {
        background: #2187FF;
        &:hover {
            background: #0070F4;
        }
    }
    .opponent__button_orange {
        background: #FF7245;
        &:hover {
            background: #F55A29;
        }
    }
</style>
